const {KitModule, registerModule} = window;
class PaginatedPostsList extends KitModule {
  constructor($element) {
    super($element);
    this.initialize();
  }
  /**
   * Implemented as a standalone function so it can be called again from
   * liveLoadResults()
   */
  bindEvents() {
    this.$linksMenu?.addEventListener('change', this.handleSelectLink.bind(this));
    this.$timeLinksMenu?.addEventListener('change', this.handleSelectLink.bind(this));
    this.$liveLoadLinks.forEach(($liveLoadLink) => {
      $liveLoadLink.addEventListener('click', this.handleLiveLoad.bind(this));
    });
  }
  async handleLiveLoad(event) {
    event.preventDefault();
    const url = new URL(event.target.href);
    url.hash = '';
    this.liveLoadResults(url, event.target);
  }
  handleSelectLink(event) {
    const selectedOption = event.target.selectedOptions[0];
    if (selectedOption) {
      this.liveLoadResults(selectedOption.dataset.url);
    }
  }

  initialize() {
    this.bindEvents();
    this.initShowMore();
    this.deferReorderIfHidden();
  }

  initShowMore() {
    const btn = this.$element.querySelector('[data-show-more-btn]');
    if (!btn) return;

    const nav = btn.closest('.paginatedPostsList-categories');
    if (!nav) return;

    const list = nav.querySelector('[data-categories-list]');
    if (!list) return;

    if (list.scrollHeight > list.clientHeight) {
      list.setAttribute('data-overflow', '');
    }

    if (!btn.hasAttribute('data-listener')) {
      btn.setAttribute('data-listener', 'true');
      btn.addEventListener('click', () => {
        list?.toggleAttribute('data-expanded');
        btn.toggleAttribute('data-expanded');
      });
    }
  }

  /**
   * Move the selected category to directly after "ALL" only when:
   * - We are in cards layout
   * - The categories list overflows (Show more would be needed)
   * - The selected category is currently below the fold (hidden)
   */
  reorderCategoriesIfHidden() {
    const $cardsMain = this.$element.querySelector('.paginatedPostsList__main--cards');
    if (!$cardsMain) return;

    const $list = $cardsMain.querySelector('[data-categories-list]');
    if (!$list) return;

    // Don't reorder when expanded
    if ($list.hasAttribute('data-expanded')) return;

    // Only if overflow exists
    if (!($list.scrollHeight > $list.clientHeight)) return;

    const $selectedLink = $list.querySelector('a[aria-current="page"]');
    if (!$selectedLink) return;

    const linkBottom = $selectedLink.offsetTop + $selectedLink.offsetHeight;
    if (linkBottom <= $list.clientHeight) return; // already visible

    const $selectedLi = $selectedLink.closest('li');
    if (!$selectedLi) return;

    const items = Array.from($list.children).filter((el) => el.tagName === 'LI');
    let insertIndex = 0;
    for (let i = 0; i < items.length; i += 1) {
      const a = items[i].querySelector('a');
      if (a && a.textContent.trim().toLowerCase() === 'all') {
        insertIndex = i + 1;
        break;
      }
    }

    const referenceNode = items[insertIndex] || null;
    if ($selectedLi !== referenceNode) {
      $list.insertBefore($selectedLi, referenceNode);
    }

    // Intentionally do not reorder the dropdown; only reorder the visible list
  }

  // Run after layout/DOM settles
  deferReorderIfHidden() {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => this.reorderCategoriesIfHidden());
    } else {
      setTimeout(() => this.reorderCategoriesIfHidden(), 0);
    }
  }

  /**
   * @param {string} url
   * @param {HTMLElement} $liveLoadLink
   * @return {Promise}
   */
  async liveLoadResults(url, $liveLoadLink) {
    try {
      // Fetch the linked page, parse the results as HTML, and replace matching
      // elements on this page.
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const $remoteFeatured = doc.querySelector('[data-js-child="$featured"]');
      this.$featured?.replaceWith($remoteFeatured);

      const $remoteGrid = doc.querySelector('[data-js-child="$liveGrid"]');
      this.$liveGrid?.replaceWith($remoteGrid);

      const $remoteResults = doc.querySelector('[data-js-child="$posts"]');
      this.$posts?.replaceWith($remoteResults);

      const $remoteTabsList = doc.querySelector('[data-js-child="$tabsList"]');
      this.$tabsList?.replaceWith($remoteTabsList);

      const $remoteCategoriesList = doc.querySelector('[data-js-child="$categoriesList"]');
      this.$categoriesList?.replaceWith($remoteCategoriesList);

      delete this.$liveLoadLinks;
      delete this.$postLinks;

      this.updateChildren();
      this.bindEvents();
      this.initShowMore();
      this.deferReorderIfHidden();

      if ($liveLoadLink?.dataset.scrollToFirstPost) {
        const options = {
          behavior: 'smooth',
        };
        if (this.$tabsList) {
          this.$tabsList?.scrollIntoView(options);
        } else {
          this.$postLinks?.[0].scrollIntoView(options);
        }
      }
    } catch (error) {
      /* eslint-disable-next-line */
      console.error(error);
      // If fetching remote results fails for any reason, tell the browser to
      // move on to the originally linked page.
      window.location.href = url;
    }
  }
  unmount() {
    //
  }
}
registerModule('PaginatedPostsList', PaginatedPostsList);
